import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Course } from "src/app/_models/Course";
import {
  AddLearnerCourseBatch,
  LearnerCourse,
  LearnerCoursesList,
  UpdateLearnerCourseDisabledDto,
  UpdateLearnerCourseDto,
} from "src/app/_models/LearnerCourse";
import { LearnerCourseLog } from "src/app/_models/LearnerCourseLog";
import { MessageResultDto } from "src/app/_models/MessageResultDto";
import { LearnerCourseActionTypes } from "src/app/constants/StoreConstants";

export const ResetLearnerCourseState = createAction(
  LearnerCourseActionTypes.ResetLearnerCourseState
);

export const GetLearnerCoursesList = createAction(
  LearnerCourseActionTypes.GetLearnerCoursesList,
  props<{ learnerId: number; langId: string }>()
);

export const GetLearnerCoursesListSuccess = createAction(
  LearnerCourseActionTypes.GetLearnerCoursesListSuccess,
  props<{ result: LearnerCoursesList[] }>()
);

export const GetLearnerCoursesListError = createAction(
  LearnerCourseActionTypes.GetLearnerCoursesListError,
  props<{ error: any }>()
);

export const UpdateDisableLearnerCourse = createAction(
  LearnerCourseActionTypes.UpdateDisableLearnerCourse,
  props<{ params: UpdateLearnerCourseDisabledDto }>()
);

export const UpdateDisableLearnerCourseSuccess = createAction(
  LearnerCourseActionTypes.UpdateDisableLearnerCourseSuccess,
  props<{ params: MessageResultDto }>()
);

export const UpdateDisableLearnerCourseError = createAction(
  LearnerCourseActionTypes.UpdateDisableLearnerCourseError,
  props<{ error: HttpErrorResponse }>()
);

export const ReAssignLearnerToAssessment = createAction(
  LearnerCourseActionTypes.ReAssignLearnerToAssessment,
  props<{courseId: number}>()
);

export const ReAssignLearnerToAssessmentSuccess = createAction(
  LearnerCourseActionTypes.ReAssignLearnerToAssessmentSuccess,
  props<{result: number}>()
);

export const ReAssignLearnerToAssessmentError = createAction(
  LearnerCourseActionTypes.ReAssignLearnerToAssessmentError,
  props<{error: HttpErrorResponse}>()
);

export const GenerateLearningPlan = createAction(
  LearnerCourseActionTypes.GenerateLearningPlan,
  props<{courseId: number}>()
);

export const GenerateLearningPlanSuccess = createAction(
  LearnerCourseActionTypes.GenerateLearningPlanSuccess,
  props<{result: number}>()
);

export const GenerateLearningPlanError = createAction(
  LearnerCourseActionTypes.GenerateLearningPlanError,
  props<{error: HttpErrorResponse}>()
);

export const GetLearnerCourseLog = createAction(
  LearnerCourseActionTypes.GetLearnerCourseLog,
  props<{learnerId: number, courseId: number}>()
);

export const GetLearnerCourseLogSuccess = createAction(
  LearnerCourseActionTypes.GetLearnerCourseLogSuccess,
  props<{result: LearnerCourseLog}>()
);

export const GetLearnerCourseLogError = createAction(
  LearnerCourseActionTypes.GetLearnerCourseLogError,
  props<{error: HttpErrorResponse}>()
);

export const GetLearnerCourse = createAction(
  LearnerCourseActionTypes.GetLearnerCourse,
  props<{ learnerId: number; courseId: number }>()
);

export const GetLearnerCourseSuccess = createAction(
  LearnerCourseActionTypes.GetLearnerCourseSuccess,
  props<{ result: LearnerCourse }>()
);

export const GetLearnerCourseError = createAction(
  LearnerCourseActionTypes.GetLearnerCourseError,
  props<{ error: HttpErrorResponse }>()
);

export const UpdateLearnerCourse = createAction(
  LearnerCourseActionTypes.UpdateLearnerCourse,
  props<{ updated: UpdateLearnerCourseDto }>()
);

export const UpdateLearnerCourseSuccess = createAction(
  LearnerCourseActionTypes.UpdateLearnerCourseSuccess,
  props<{ result: UpdateLearnerCourseDto }>()
);

export const UpdateLearnerCourseError = createAction(
  LearnerCourseActionTypes.UpdateLearnerCourseError,
  props<{ error: any }>()
);

export const GetLearnersLearnerCourseLogStatus = createAction(
  LearnerCourseActionTypes.GetLearnersLearnerCourseLogStatus,
  props<{ courseId: number }>()
);

export const GetLearnersLearnerCourseLogStatusSuccess = createAction(
  LearnerCourseActionTypes.GetLearnersLearnerCourseLogStatusSuccess,
  props<{ result: LearnerCourseLog }>()
);

export const GetLearnersLearnerCourseLogStatusError = createAction(
  LearnerCourseActionTypes.GetLearnersLearnerCourseLogStatusError,
  props<{ error: HttpErrorResponse }>()
);

export const AddLearnerCourseList = createAction(
  LearnerCourseActionTypes.AddLearnerCourseList,
  props<{ list: AddLearnerCourseBatch[] }>()
);

export const AddLearnerCourseListSuccess = createAction(
  LearnerCourseActionTypes.AddLearnerCourseListSuccess,
  props<{ result: boolean }>()
);

export const AddLearnerCourseListError = createAction(
  LearnerCourseActionTypes.AddLearnerCourseListError,
  props<{ error: HttpErrorResponse }>()
);

export const ResetAddLearnerCourseList = createAction(
  LearnerCourseActionTypes.ResetAddLearnerCourseList
);

export const GetLearnerCourseScreenerResult = createAction(
  LearnerCourseActionTypes.GetLearnerCourseScreenerResult,
  props<{langId: string, langCode: string}>()
);

export const GetLearnerCourseScreenerSuccess = createAction(
  LearnerCourseActionTypes.GetLearnerCourseScreenerSuccess,
  props<{courses: Course[]}>()
);

export const GetLearnerCourseScreenerError = createAction(
  LearnerCourseActionTypes.GetLearnerCourseScreenerError,
  props<{error: HttpErrorResponse}>()
);

